import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step3 } from '../../../../shared/models/component-messages/mapaAN/step3';

@Component({
  selector: 'app-annulation',
  templateUrl: './annulation.component.html'
})
export class AnnulationComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'Annulation'
  @Input() parentForm: FormGroup;
	@Input() annulation: String;
  @Input() disabled: boolean;

  constructor() { }

  public ngOnInit() {
  }


  public step3 = new Step3();




  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }


}

